<template>
  <div>
    Invoices
  </div>
</template>

<script>
export default {

}
</script>
